const KNOWN_FILTER_IDS = ['all','unread','inquiry','cart','order','invoice','sale','shipped','tracking'];

export const getGsmTag = (c) => {
  if (c.last_msg_type === 'template' || c.last_msg_type === 'invoice') {
    if (c.last_template_name) return c.last_template_name;
    const m = (c.last_message || '').toLowerCase();
    if (m.includes('bus ticket')) return 'Ticket';
    if (m.includes('cashback')) return 'Cashback';
    if (m.includes('location')) return 'Location';
    return 'Invoice';
  }
  return c.last_msg_type;
};

export const getFilterTabs = (bizId, conversations, tagConfig) => {
  const unreadCount = conversations.filter(c => Number(c.unread_count) > 0).length;
  const unreadLabel = 'Unread' + (unreadCount > 0 ? ' (' + unreadCount + ')' : '');

  if (Number(bizId) === 22) {
    return [
      { id: 'all', label: 'All' },
      { id: 'unread', label: unreadLabel },
      { id: 'inquiry', label: '💬 Inquiry' },
      ...['location','tracking','cashback','custom'].map(t => ({ id: t, label: t.charAt(0).toUpperCase() + t.slice(1) })),
      ...[...new Set(conversations.flatMap(c => {
        if (c.last_msg_type && !['text','image','audio','video','document','checkout_creation','shopify','template','invoice','sale','shipped','inv'].includes(c.last_msg_type)) {
          return [c.last_msg_type];
        }
        return [];
      }))].map(t => ({ id: t, label: t.charAt(0).toUpperCase() + t.slice(1) })),
    ];
  }
  if (tagConfig && tagConfig.length) {
    return [
      { id: 'all', label: 'All' },
      { id: 'unread', label: unreadLabel },
      { id: 'inquiry', label: '💬 Inquiry' },
      ...tagConfig.map(t => ({ id: t.key, label: t.label })),
    ];
  }
  return [
    { id: 'all', label: 'All' },
    { id: 'unread', label: unreadLabel },
    { id: 'inquiry', label: '💬 Inquiry' },
    ...(Number(bizId) === 26 ? [] : [{ id: 'cart', label: '🛒 Cart' }]),
    { id: 'order', label: '📦 Order' },
    { id: 'invoice', label: '🧾 Invoice' },
    { id: 'sale', label: '🛍️ Sale' },
    ...(Number(bizId) === 26 ? [{ id: 'tracking', label: '📦 Tracking' }] : [{ id: 'shipped', label: '🚚 Shipped' }]),
  ];
};

export const applyInboxFilter = (conversations, filter) => {
  let list = conversations;
  if (filter === 'unread') return list.filter(c => c.unread_count > 0);
  if (filter === 'inquiry') return list.filter(c => c.has_inbound === 1 || c.has_inbound === true);
  if (filter === 'cart') return list.filter(c => c.has_cart == 1);
  if (filter === 'order') return list.filter(c => c.last_msg_type === 'shopify');
  if (filter === 'invoice') return list.filter(c => c.last_msg_type === 'template' || c.last_msg_type === 'invoice');
  if (filter === 'sale') return list.filter(c => c.last_msg_type === 'sale');
  if (filter === 'shipped') return list.filter(c => c.last_msg_type === 'shipped' || c.last_msg_type === 'shopify_fulfillment');
  if (filter === 'tracking') return list.filter(c => c.last_msg_type === 'Tracking');
  if (!KNOWN_FILTER_IDS.includes(filter)) {
    return list.filter(c => getGsmTag(c) === filter);
  }
  return list;
};

export const getInboxCounts = (conversations, tagConfig, bizId) => {
  const base = {
    all: conversations.length,
    unread: conversations.filter(c => c.unread_count > 0).length,
    inquiry: conversations.filter(c => c.has_inbound === 1 || c.has_inbound === true).length,
    cart: conversations.filter(c => c.has_cart == 1).length,
    order: conversations.filter(c => c.last_msg_type === 'shopify').length,
    invoice: conversations.filter(c => c.last_msg_type === 'template' || c.last_msg_type === 'invoice').length,
    sale: conversations.filter(c => c.last_msg_type === 'sale').length,
    shipped: conversations.filter(c => c.last_msg_type === 'shipped' || c.last_msg_type === 'shopify_fulfillment').length,
    tracking: conversations.filter(c => c.last_msg_type === 'Tracking').length,
  };
  if (tagConfig && tagConfig.length) {
    for (const t of tagConfig) {
      base[t.key] = conversations.filter(c => getGsmTag(c) === t.key).length;
    }
  }
  if (Number(bizId) === 22) {
    const tabs = getFilterTabs(bizId, conversations, tagConfig);
    for (const tab of tabs) {
      if (!(tab.id in base)) {
        base[tab.id] = applyInboxFilter(conversations, tab.id).length;
      }
    }
  }
  return base;
};
